{
    "BILLED": "Fakturiert",
    "CANCELLED": "Storniert",
    "LOST": "Verloren",
    "OPEN_IN_PICKING": "Offen in Kommiss.",
    "OPEN": "Offen",
    "OTHER": "Anderes",
    "PARTIALLY_BILLED": "Teilw. Fakturiert",
    "PARTIALLY_PICKED": "Teilw. Kommiss.",
    "PARTIALLY_RECEIVED": "Teilw. Erhalten",
    "PARTIALLY_SHIPPED": "Teilw. Geliefert",
    "PENDING": "Ausstehend",
    "PICKED": "Kommissioniert",
    "PROCESSED_INTERNALLY": "Intern Verarbeitet",
    "RECEIVED": "Erhalten",
    "RELEASED_FOR_BILLING": "Zur Faktura freig.",
    "RELEASED_FOR_DELIVERY": "Zur Lieferung freig.",
    "RETURNED": "Retourniert",
    "REVISED": "Überarbeitet",
    "SHIPPED": "Geliefert",
    "UNKNOWN": "Unbekannt"
}
